import { BackGlassPanel } from './BackGlassPanel'
import { FrontGlassPanel } from './FrontGlassPanel'
import { SolarPanels } from './SolarPanels'
import { useMeasures } from '../../../../../hooks/state/useMeasures'
import { useRoof } from '../../../../../hooks/state/useRoof'

interface Props {
  positionX: number
}

export const Panel = ({ positionX }: Props): JSX.Element => {
  const {
    polesTopNumber,
    userAngle,
    userWidth,
    verandaTyp,
    roofLogWidth,
    schwelleSize,
    isQubus,
  } = useMeasures()
  const { roofGlassDepth } = useRoof()
  const roofWidth = userWidth / (polesTopNumber - 1)
  const position = roofWidth! * positionX - verandaTyp.roofBar.depth / 2
  const length =
      roofLogWidth +
      schwelleSize.depth +
      (isQubus ? verandaTyp.log.width : schwelleSize.depth),
    width = verandaTyp.roofBar.width,
    deg = userAngle,
    rad = (deg * Math.PI) / 180,
    offset = Math.min(Math.tan(rad) * width, length / 2)

  return (
    <group
      position={[
        (userWidth! - verandaTyp.roofBar.depth - roofWidth!) / 2 - position,
        verandaTyp.roofBar.width + roofGlassDepth / 2,
        -offset,
      ]}
    >
      <FrontGlassPanel positionX={positionX} />
      <group position={[-roofWidth / 2, 0, +offset]}>
        <SolarPanels />
      </group>

      <BackGlassPanel positionX={positionX} />
    </group>
  )
}
